import { render, staticRenderFns } from "./ResumenVotacion.vue?vue&type=template&id=00f14961"
import script from "./ResumenVotacion.vue?vue&type=script&lang=js"
export * from "./ResumenVotacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports